"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const fi_1 = require("react-icons/fi");
require("./NotificationAdmin.css");
const react_router_dom_1 = require("react-router-dom");
const NotificationNavTabs_1 = __importDefault(require("./NotificationNavTabs"));
const AddNotificationsModal_1 = __importDefault(require("./Modals/AddNotificationsModal"));
const notification_api_1 = require("../../../utils/api/notification/notification.api");
const axios_1 = __importDefault(require("axios"));
const hook_1 = require("../../../redux/hook");
const fa6_1 = require("react-icons/fa6");
const NotificationAdmin = () => {
    const { token } = (0, hook_1.useAppSelector)((state) => state.user);
    const [addNotifs, setAddNotifs] = (0, react_1.useState)(false);
    const [isLoading2, setIsLoading2] = (0, react_1.useState)(false);
    const handleAddNotifsModal = () => setAddNotifs(true);
    const { data, isLoading } = (0, notification_api_1.useGetNotificationsPublieesQuery)({});
    const exportNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading2(true);
        try {
            const response = yield axios_1.default.get(`/api/v1/app/exportNotifications`, {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            const resp = response.data;
            if (resp.success) {
                const fileUrl = resp.file_url;
                const fullFileName = fileUrl.split("/").pop() || "export.xlsx";
                const baseName = fullFileName.replace(/\.[^/.]+$/, "");
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("target", "_blank");
                link.setAttribute("download", `${baseName}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading2(false);
        }
    });
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Notifications"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Notifications"),
                                react_1.default.createElement("div", { className: "sunu-autoroute-admin-btn-add-container" },
                                    react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-import", onClick: exportNotifications },
                                        react_1.default.createElement(fa6_1.FaFileExport, null),
                                        isLoading2 ? "En cours.." : 'Exporter les notifications')),
                                react_1.default.createElement("div", { className: "sunu-autoroute-admin-btn-add-container" },
                                    react_1.default.createElement("button", { className: "sunu-autoroute-admin-btn-add", onClick: handleAddNotifsModal },
                                        react_1.default.createElement(fi_1.FiPlusSquare, null),
                                        " Ajouter une notification"),
                                    react_1.default.createElement(AddNotificationsModal_1.default, { addNotifs: addNotifs, setAddNotifs: setAddNotifs })))),
                        react_1.default.createElement("div", { className: "row mb-4" },
                            react_1.default.createElement("div", { className: "col-lg-3 col-md-6 mb-3 dis-flex" },
                                react_1.default.createElement("div", { className: "item-stat-dashboad-view" },
                                    react_1.default.createElement("div", { className: "content-stat-dashboard-view" },
                                        react_1.default.createElement("div", { className: "content-text-item-stat-dashboad-view w-100" },
                                            react_1.default.createElement("div", { className: "content-item-stat-dashboad-view d-flex justify-content-between align-items-start mb-3" },
                                                react_1.default.createElement("img", { src: "/images/icons/user.svg", alt: "visiteurs", className: "data-icon-dashboard-admin" }),
                                                react_1.default.createElement("div", { className: "content-item-icon-stat-dashboard-view" },
                                                    react_1.default.createElement("p", { className: "chiffre-item-stat-dashboad-view d-flex align-items-center gap-1 mb-1" },
                                                        isLoading ? (react_1.default.createElement("div", { className: "d-flex align-items-center gap-2" },
                                                            react_1.default.createElement("i", { className: "fa fa-spinner fa-spin " }))) : (data === null || data === void 0 ? void 0 : data.pourcentage_lecture),
                                                        "%"))),
                                            react_1.default.createElement("p", { className: "titre-item-stat-dashboad-view" }, "Pourcentage de lecture")))))),
                        react_1.default.createElement("div", { className: "pb-4 tabs__wrapper" },
                            react_1.default.createElement(NotificationNavTabs_1.default, null)),
                        react_1.default.createElement("div", { className: "outlet__wrapper pricing" },
                            react_1.default.createElement(react_router_dom_1.Outlet, null))))))));
};
exports.default = NotificationAdmin;
